import React from 'react';
import './About.css'
const About = () => {
    return(
        <div>
            <span className='titleCus'>About</span>
            <span className='caption'>This website is for who want to explore about movie and tv series. I also make addition feature that can practically buy the movie,
                but it is not for real you buying a movie. Because this website made not for doing some transaction or other money interaction.
                I just added this feature is for train my skill and my knowledge about hooks and javascript. So I hope whoever visitor can understand and enjoy 
                exploring movie and tv series. 
            </span><br />
            <span className='titleCus'>Disclaimer</span>
            <span className='caption'>
                This website is fully consume API from <a href="https://www.themoviedb.org/">TMDB</a> you can also visit tmdb web for more information about the API. 
                I also helped from tutorial youtube channel named RoadsideCoder Thank you for awesome tutorial. <a href="https://www.youtube.com/watch?v=vxUfx4aM5d8">RoadsideCoder</a>
            </span>
        </div>
    )
}

export default About;


// WEBPACK FOOTER //
// ./src/Pages/About/About.js